import React from 'react';
import { OrdersHubApi, ProductsApi } from '@coretava/api/ecommerce-service';
import { SpinTheWheelApi, UserReferralsApi, UserSurveysApi } from '@coretava/api/events-service';
import { UserStore } from '../store/user';

export const useUserReferralsApi = (): UserReferralsApi => React.useMemo(() => new UserReferralsApi({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
  accessToken: UserStore.token,
}), [UserStore.token]);

export const useUserSurveysApi = (): UserSurveysApi => React.useMemo(() => new UserSurveysApi({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
  accessToken: UserStore.token,
}), [UserStore.token]);

export const useSpinTheWheelApi = (): SpinTheWheelApi => React.useMemo(() => new SpinTheWheelApi({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
  accessToken: UserStore.token,
}), [UserStore.token]);

export const useOrdersHubApi = (): OrdersHubApi => React.useMemo(() => new OrdersHubApi({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
  accessToken: UserStore.token,
}), [UserStore.token]);

export const useProductsApi = (): ProductsApi => React.useMemo(() => new ProductsApi({
  isJsonMime(): boolean {
    return true;
  },
  basePath: process.env.BASE_API_URL,
  accessToken: UserStore.token,
}), [UserStore.token]);
